import { render, staticRenderFns } from "./badge-circular.vue?vue&type=template&id=5a465caf"
import script from "./badge-circular.vue?vue&type=script&lang=js"
export * from "./badge-circular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports